import React, { useState, useEffect } from 'react';
import { useStores } from '../stores/context';
import FullPageLoader from './FullPageLoader';
import '../App.css';

const Token = () => {
    const [loading, setLoading] = useState(true);
    const [tooltipContent, setTooltipContent] = useState('Copy Id token to clipboard.');
    const { authStore, alertStore } = useStores();
    const year = new Date().getFullYear();

    const tokenValue = localStorage.getItem('authorization').replace('Bearer ', '');

    useEffect(() => {
        authStore.completeLogin().then(setTimeout(() => setLoading(false), 400));
    }, [authStore]);

    function copyToken(tokenValue) {
        navigator.clipboard
            .writeText(tokenValue)
            .then(() => setTooltipContent('Token has been copied.'))
            .catch(() => alertStore.error('Failed to copy token.'));
    }

    return loading ? 
        <FullPageLoader /> : 
        (
            <div>
                <div className="login">
                    <div className="logo">
                        <img alt="MAN Logo" src={process.env.REACT_APP_MAN_LOGO_URL} />
                    </div>
                    <div className="login-box">
                        <div>
                            <div className="tooltip">
                                <button className="login-button" onClick={() => copyToken(tokenValue)}>
                                    <span className="tooltiptext" >{tooltipContent}</span>
                                    Copy Token
                                </button>
                            </div>
                            <button className="login-button" onClick={authStore.logout}>
                                Sign Out
                            </button>
                        </div>
                    </div>
                    <p className="footer" >
                        &copy; {year} <a className="footer" href="https://man.eu">man.eu</a> – All rights reserved
                    </p>
                </div>
            </div>
        );
};

export default Token;
